// extracted by mini-css-extract-plugin
export var attribution = "_1x-4";
export var authorName = "_1x-5";
export var continueButton = "_1x-18";
export var continueIcon = "_1x-1a";
export var continueText = "_1x-19";
export var intakeSpin = "_1x-1c";
export var option = "_1x-f";
export var optionCard = "_1x-u";
export var optionContent = "_1x-v";
export var optionGrid = "_1x-11";
export var optionIcon = "_1x-x";
export var optionIconBox = "_1x-w";
export var optionLabel = "_1x-y";
export var optionList = "_1x-e";
export var optionPill = "_1x-12";
export var optionPillBadge = "_1x-15";
export var optionPillIcon = "_1x-13";
export var optionPillLabel = "_1x-14";
export var optionRadio = "_1x-z";
export var optionRadioInner = "_1x-10";
export var optionReveal = "_1x-h";
export var optionRevealDelay0 = "_1x-i";
export var optionRevealDelay1 = "_1x-j";
export var optionRevealDelay10 = "_1x-s";
export var optionRevealDelay11 = "_1x-t";
export var optionRevealDelay2 = "_1x-k";
export var optionRevealDelay3 = "_1x-l";
export var optionRevealDelay4 = "_1x-m";
export var optionRevealDelay5 = "_1x-n";
export var optionRevealDelay6 = "_1x-o";
export var optionRevealDelay7 = "_1x-p";
export var optionRevealDelay8 = "_1x-q";
export var optionRevealDelay9 = "_1x-r";
export var optionSelected = "_1x-g";
export var questionsBlock = "_1x-17";
export var quote = "_1x-3";
export var spacer = "_1x-b";
export var spinner = "_1x-1b";
export var spinnerOverlay = "_1x-1d";
export var stepCenteredContent = "_1x-9";
export var stepInner = "_1x-6";
export var stepInnerFullWidth = "_1x-7";
export var stepInnerLockScroll = "_1x-8";
export var stepTransitionFrame = "_1x-a";
export var subtitle = "_1x-d";
export var testimonial = "_1x-2";
export var title = "_1x-c";
export var trustedBy = "_1x-0";
export var trustedByLabel = "_1x-1";
export var welcomeBlock = "_1x-16";